import { Component } from '@angular/core';

@Component({
  selector: 'meeting-management',
  template: '<router-outlet></router-outlet>',
})
export class MeetingManagementPage {}
